import { isColumnVisibleByDefault } from '../../../utils/partialPermissionUtils';

const wbsPreCol = (gantt, t) => {
  const name = 'WBS_PRE_COL';
  const isVisible = isColumnVisibleByDefault(name);

  return {
    width: 30,
    name: name,
    label: '',
    hide: !isVisible,
    data_type: 'string',
    ignore_as_column: true,
    template: (activity) => '',
  };
};

export default wbsPreCol; 